module.exports = __webpack_public_path__ + "img/2020-07-27.396184fb.jpg";